<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- لوحة التحكم -->
    <div class="card shadow-sm border-top-warning mb-3 no-print">
      <div class="card-body py-3">
        <div class="row align-items-center">
          <div class="col-md-6">
            <h5 class="fw-bold text-dark mb-0">
              <i class="fas fa-table ms-2 text-warning"></i> العرض الشامل للمستحقين للرأفة
            </h5>
            <small class="text-muted">يعرض الطلاب الذين لديهم مادة واحدة على الأقل في نطاق الرأفة</small>
          </div>
          <div class="col-md-3">
            <div class="input-group">
              <span class="input-group-text fw-bold">حدود الرأفة</span>
              <select v-model="margin" @change="fetchData(1)" class="form-select border-warning fw-bold">
                <option :value="1">1 درجة</option>
                <option :value="1.5">1.5 درجة</option>
                <option :value="2">2 درجة</option>
                <option :value="3">3 درجات</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
             <!-- زر التطبيق الجماعي -->
             <button 
                @click="applyBulk" 
                class="btn btn-success w-100 fw-bold"
                :disabled="allMercyCases.length === 0"
             >
               <i class="fas fa-check-double ms-2"></i> جبر الكل ({{ allMercyCases.length }} مادة)
             </button>
          </div>
        </div>
      </div>
    </div>

    <!-- الجدول الشامل -->
    <div class="card shadow-sm">
      <div class="table-responsive">
        <table class="table table-bordered table-hover text-center align-middle mb-0">
          <thead class="table-dark">
            <tr>
              <th rowspan="2" width="5%">#</th>
              <th rowspan="2" width="10%">الجلوس</th>
              <th rowspan="2" width="20%">اسم الطالب</th>
              <!-- حلقة تكرار لرسم هيدر المواد -->
              <th v-for="sub in subjects" :key="sub.id">
                {{ sub.name }} <br> <span class="badge bg-light text-dark">{{ sub.main }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(student, idx) in students.data" :key="student.id">
              <td>{{ idx + 1 }}</td>
              <td class="fw-bold">{{ student.Seating_No_1 }}</td>
              <td class="text-start fw-bold text-primary">{{ student.Arabic_Name }}</td>
              
              <!-- حلقة تكرار لدرجات المواد -->
              <td v-for="sub in subjects" :key="sub.id" class="p-1">
                
                <!-- 1. حالة تستحق الرأفة -->
                <div v-if="isMercyNeeded(student, sub)" class="mercy-cell bg-warning-subtle p-2 rounded">
                  <div class="text-danger fw-bold text-decoration-line-through small">{{ student[sub.code] }}</div>
                  
                  <!-- زر الجبر الفردي -->
                  <button 
                    @click="applySingle(student, sub)" 
                    class="btn btn-sm btn-outline-danger fw-bold w-100 mt-1"
                    style="font-size: 0.8rem;"
                  >
                    جبر ({{ sub.main }})
                  </button>
                </div>

                <!-- 2. حالة راسب (بعيد عن الرأفة) -->
                <div v-else-if="isFail(student, sub)" class="bg-danger text-white p-2 rounded fw-bold">
                   {{ student[sub.code] }}
                </div>

                <!-- 3. حالة ناجح -->
                <div v-else class="fw-bold text-success">
                   {{ student[sub.code] }}
                </div>

              </td>
            </tr>
            
            <tr v-if="students.data && students.data.length === 0">
                <td :colspan="3 + subjects.length" class="py-5 text-muted">لا توجد حالات في نطاق {{ margin }} درجة.</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- Pagination (البجنيشن المضاف) -->
      <div class="card-footer bg-white d-flex justify-content-center" v-if="students.last_page > 1">
        <nav aria-label="Page navigation">
          <ul class="pagination mb-0" dir="ltr">
            
            <li class="page-item" :class="{ disabled: students.current_page === 1 }">
              <button class="page-link" @click="changePage(students.current_page - 1)">Previous</button>
            </li>

            <!-- عرض أرقام الصفحات -->
            <li class="page-item active" aria-current="page">
               <span class="page-link">{{ students.current_page }} / {{ students.last_page }}</span>
            </li>

            <li class="page-item" :class="{ disabled: students.current_page === students.last_page }">
              <button class="page-link" @click="changePage(students.current_page + 1)">Next</button>
            </li>

          </ul>
        </nav>
      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "MercyFullTable",
  data() {
    return {
      loading: false,
      margin: 1,
      students: { data: [] }, // تهيئة مبدئية لتجنب الأخطاء
      subjects: [] 
    };
  },
  computed: {
    // تجميع الحالات للتطبيق الجماعي
    allMercyCases() {
        if (!this.students.data) return [];
        let cases = [];
        this.students.data.forEach(std => {
            this.subjects.forEach(sub => {
                if (this.isMercyNeeded(std, sub)) {
                    cases.push({
                        student_id: std.id,
                        column: sub.code, // تم التصحيح ليتوافق مع بياناتك
                        new_degree: sub.main // تم التصحيح
                    });
                }
            });
        });
        return cases;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData(page = 1) {
      this.loading = true;
      try {
        const res = await api.get('/admin/mercy-full-view', {
            params: { margin: this.margin, page: page }
        });
        this.students = res.data.students;
        this.subjects = res.data.subjects;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    // دالة تغيير الصفحة
    changePage(page) {
      if (page > 0 && page <= this.students.last_page) {
        this.fetchData(page);
      }
    },

    // --- دوال المنطق (تم تصحيح المسميات) ---
    
    isFail(student, subject) {
        // استخدام code و main بدلاً من column_name و min_degree
        return Number(student[subject.code]) < Number(subject.main);
    },

    isMercyNeeded(student, subject) {
        const score = Number(student[subject.code]);
        const min = Number(subject.main);
        // شرط الرأفة
        return score < min && score >= (min - this.margin);
    },

    // --- دوال الحفظ ---

    async applySingle(student, subject) {
        if(!confirm(`جبر درجة ${subject.name} للطالب ${student.Arabic_Name}؟`)) return;

        try {
            await api.post('/admin/mercy-apply', {
                updates: [{
                    student_id: student.id,
                    column: subject.code, // إرسال اسم العمود الصحيح للباك إند
                    new_degree: subject.main
                }]
            });
            
            // تحديث الواجهة فوراً
            student[subject.code] = subject.main;
            
        } catch (error) {
            alert("فشل التحديث");
        }
    },

    async applyBulk() {
        const count = this.allMercyCases.length;
        if(!confirm(`هل أنت متأكد من جبر ${count} حالة مستحقة للرأفة في هذه الصفحة؟`)) return;

        try {
            await api.post('/admin/mercy-apply', {
                updates: this.allMercyCases
            });
            
            alert("تم التعديل بنجاح");
            // إعادة تحميل الصفحة الحالية لرؤية التغييرات
            this.fetchData(this.students.current_page); 
            
        } catch (error) {
            alert("فشل التحديث الجماعي");
        }
    }
  }
};
</script>

<style scoped>
.mercy-cell {
    border: 2px dashed #ffc107;
    transition: all 0.3s;
}
.mercy-cell:hover {
    background-color: #fff3cd !important;
    transform: scale(1.02);
}
.text-decoration-line-through {
    text-decoration: line-through;
    opacity: 0.7;
}
</style>